<!-- MainLayout.vue -->
<template>
    <div id="app" class="h-full bg-white">
      <div class="h-full">
      <router-view />
    </div></div>
</template>